import { Button } from '@mui/material';
import type { DefaultTheme } from 'styled-components/macro';
import styled from 'styled-components/macro';

export const ButtonStyled = styled(Button)`
  && {
    text-transform: none;
    border-radius: ${({ theme }: { theme: DefaultTheme }): string => theme.radius['2xl']};
    border-color: ${({ theme }: { theme: DefaultTheme }): string => theme.colors.primary.variant6};
    padding: 2px 12px;
    font-size: ${({ theme }: { theme: DefaultTheme }): string => theme.fontSize.sm};
  }
`;
